import { getBrandFromHost } from "@theme/config/theme.config";
import { getEnvironmentType } from "@utils/helpers/getEnvironmentType";
import { fgfSettings } from "@src/config/fgf";
import { nimbleSettings } from "@src/config/nimble";

const host = window.location.hostname.toLowerCase();
const brand = getBrandFromHost(host);
const environmentType = getEnvironmentType(brand);
const settings = environmentType === "NIM" ? nimbleSettings : fgfSettings;

const environmentSettings = {
  ...settings
};

export default environmentSettings;